// extracted by mini-css-extract-plugin
export default {"homeLink":"HomeLink_homeLink__Dq7Ty","logo":"HomeLink_logo__O--g2"};